// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__ku-q6","logoEn":"Navbar_logoEn__Pqq+O","logoAr":"Navbar_logoAr__SJCvu","languageEn":"Navbar_languageEn__YYkk9","languageAr":"Navbar_languageAr__Vk2SK"};